import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/homePage';
import About from './pages/aboutPage';
import Reservations from './pages/reservationsPage';
import Menu from './pages/menuPage';
import WineList from './pages/wineListPage';
import Contact from './pages/contactPage';
import Careers from './pages/careersPage';
import NotFound from './pages/NotFound';
import { useTheme } from './lib/hooks/useTheme';

function App() {
  const location = useLocation();

  // Initialize theme system
  useTheme();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="reservations" element={<Reservations />} />
          <Route path="menu" element={<Menu />} />
          <Route path="wine-list" element={<WineList />} />
          <Route path="contact" element={<Contact />} />
          <Route path="careers" element={<Careers />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
